const popUpMessageReducer = (message = {}, action) => {
    switch(action.type){
        case 'SET_POPUP_MESSAGE':
            message = action.data
            return message;
        default:
            return message;
    }
}

export default popUpMessageReducer;